import $ from 'jquery';
import showConfirmationPopup from "./confirmationPopup";

$('body').on('click', 'a[data-form-toggle="action-form"]', async function (e) {
        e.preventDefault();
        const confirmation = $(this).attr('data-conformation')
        if (confirmation !== undefined && confirmation !== 'false') {
            const confirmed = await showConfirmationPopup(confirmation)
            if (!confirmed) {
                return;
            }
        }
        const $actionForm = $(this).next('action-form').clone();
        const $form = $('<form></form>')
            .append($actionForm.children());
        const attributes = $actionForm.prop("attributes");
        $.each(attributes, function () {
            $form.attr(this.name, this.value);
        });
        $form.appendTo('body').submit();

    }
)


